import { useState } from "react";

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
      <div>
        <h1 className="font-head text-2xl sm:text-3xl font-semibold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      <div className="flex gap-2 flex-wrap">{children}</div>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="ms-card p-10 flex flex-col items-center text-center gap-3">
      {Icon && (
        <div className="h-14 w-14 rounded-2xl bg-accent flex items-center justify-center">
          <Icon className="h-7 w-7 text-primary" strokeWidth={1.5} />
        </div>
      )}
      <h3 className="font-head text-lg font-semibold">{title}</h3>
      {subtitle && <p className="text-sm text-muted-foreground max-w-sm">{subtitle}</p>}
      {action}
    </div>
  );
}

export function Loader({ label = "Cargando..." }) {
  return (
    <div className="flex items-center justify-center py-16 text-muted-foreground gap-3">
      <div className="h-5 w-5 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function Pagination({ skip, limit, total, onChange }) {
  if (!total || total <= limit) return null;
  const page = Math.floor(skip / limit) + 1;
  const pages = Math.ceil(total / limit);
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 mt-4 text-sm text-muted-foreground" data-testid="pagination">
      <span>{skip + 1}–{Math.min(skip + limit, total)} de {total}</span>
      <div className="flex items-center gap-2">
        <button disabled={skip <= 0} onClick={() => onChange(Math.max(0, skip - limit))}
          className="rounded-full border border-border px-3 py-1 disabled:opacity-40 hover:bg-accent transition-colors" data-testid="pagination-prev">Anterior</button>
        <span className="px-1">Página {page} de {pages}</span>
        <button disabled={skip + limit >= total} onClick={() => onChange(skip + limit)}
          className="rounded-full border border-border px-3 py-1 disabled:opacity-40 hover:bg-accent transition-colors" data-testid="pagination-next">Siguiente</button>
      </div>
    </div>
  );
}

export function useAsync() {
  const [loading, setLoading] = useState(false);
  const run = async (fn) => {
    setLoading(true);
    try { return await fn(); } finally { setLoading(false); }
  };
  return { loading, run };
}
